import { useContext } from 'react';

import { XYChartAnnotationsConfig } from '../context/XYChartAnnotationsConfig.context.js';

export const useXYChartAnnotationsConfig = () =>
  useContext(XYChartAnnotationsConfig);
